import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';
import { DataService, EmmiterService } from './services/data.service';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { MsalService } from '@azure/msal-angular';
import { NgIdleService } from './services/ng-idle.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'WORKFLOW';

  isDisplay: boolean = false;
  isSidebarOpen: boolean = false;
  isShowLogoutAndMenuIcon: boolean = true;
  isFormBlur: boolean = false;
  isBodyBright: boolean = true;
  session_timeout_interval: number = 15;

  userInfo: UserInfo;

  currentNavigation: string = "";
  subscription: any;
  navList: any = [
    {
      heading: 'Dashboard',
      icon: 'dashboard',
      link: '/dashboard',
      pages: []
    },
    {
      heading: 'Main Heading',
      icon: 'settings',
      link: '/settings',
      pages: [
        {
          title: 'Subpage',
          link: '/settings/advanced',
          icon: ''
        }
      ]
    }
  ];

  constructor(private router: Router, activeRoute: ActivatedRoute, private authService: AuthService,
    public commonService: CommonService, public dataService: DataService, private dialog: MatDialog,
    private msalservice: MsalService, private ngIdle: NgIdleService,private memorystore: MemoryStorageService) {

    router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        this.isSidebarOpen = false;
      }
      if (event instanceof NavigationEnd && localStorage.getItem("token") != null) {
        // this.authService.validateSession().subscribe(data => {
        //   if (data) {
        //     if (data.status != "Success") {
        //       this.router.navigate(['/login']);
        //     }
        //   }
        // });
      }
      let child = activeRoute.firstChild;
      if (child?.snapshot.data) {
        this.currentNavigation = child.snapshot.data['page'];
        if (this.currentNavigation == 'login' || this.currentNavigation == "transaction" || this.currentNavigation == undefined || this.currentNavigation == "sso-login" || this.currentNavigation == 'control-panel' || this.currentNavigation == 'work-item') {
          this.isDisplay = false;
        }
        else {
          this.isDisplay = true;
        }
        if (this.currentNavigation == "transaction" || this.currentNavigation == 'ssoLogout') {
          this.isShowLogoutAndMenuIcon = false;
        }
        else {
          this.isShowLogoutAndMenuIcon = true;
        }
      }
    });

    this.userInfo = new UserInfo();
    this.subscription = EmmiterService.get("userInfo").subscribe(res => {

      //const inputValue = { firstLevelTimer :5,}
      this.session_timeout_interval = this.dataService.session_timeout_interval;
      this.initTimer(this.session_timeout_interval, 0);

      // this.userInfo.userName = this.commonService.getUserInfoFromLocalStorage('userName');
      // this.userInfo.roleName = this.commonService.getUserInfoFromLocalStorage('roleName');
      // this.userInfo.userEmail = this.commonService.getUserInfoFromLocalStorage('userEmail');
      // this.userInfo.groupName = this.commonService.getUserInfoFromLocalStorage('groupName');
      // this.userInfo.groupLogo = this.commonService.getUserInfoFromLocalStorage('groupLogo');
      // this.userInfo.projectName = this.commonService.getUserInfoFromLocalStorage('projectName');
      // this.userInfo.subgroupName = this.commonService.getUserInfoFromLocalStorage('subgroupName');
      // this.userInfo.lastLoginAt = this.commonService.getUserInfoFromLocalStorage('lastLoginAt');
      // this.userInfo.language = this.commonService.getUserInfoFromLocalStorage('language');
      // this.userInfo.HeaderLogo = this.commonService.getUserInfoFromLocalStorage('HeaderLogo');
      this.userInfo.userName = this.memorystore.getItem('userName');
      this.userInfo.roleName = this.memorystore.getItem('roleName');
      this.userInfo.userEmail = this.memorystore.getItem('userEmail');
      this.userInfo.groupName = this.memorystore.getItem('groupName');
      this.userInfo.groupLogo = this.memorystore.getItem('groupLogo');
      this.userInfo.projectName = this.memorystore.getItem('projectName');
      this.userInfo.subgroupName = this.memorystore.getItem('subgroupName');
      this.userInfo.lastLoginAt = this.memorystore.getItem('lastLoginAt');
      this.userInfo.language = this.memorystore.getItem('language');
      this.userInfo.HeaderLogo = this.memorystore.getItem('HeaderLogo');
    });

  }

  ngOnInit() {
    EmmiterService.get("userInfo").emit();
    if (this.dataService.Authentication_Type == "AZURE") {
      this.msalservice.instance.handleRedirectPromise().then(res => {
        if (res != null && res.account != null) {
          this.msalservice.instance.setActiveAccount(res.account)
        }
      })
    }
  }

  closeSidenav() { }

  logout() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to Logout?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.authService.Logout().subscribe(res => {
          if (this.dataService.is_sso == true) {
            this.router.navigate(['/sso-logout']);
            // let url = this.dataService.sso_url;
            // window.location.href = url;
          }
          else {
            this.router.navigate(['/login']);
            return;
          }
          if (this.dataService.Authentication_Type == "AZURE") {
            this.msalservice.logout();
          }
        });
      }
    });

  }

  toggleGlobalModal(event) {
    this.isFormBlur = event;
  }

  /// Idle session timeout management//


  initTimer(firstTimerValue: number, secondTimerValue: number): void {
    // Timer value initialization
    this.ngIdle.USER_IDLE_TIMER_VALUE_IN_MIN = firstTimerValue;
    this.ngIdle.FINAL_LEVEL_TIMER_VALUE_IN_MIN = secondTimerValue;
    // end

    // Watcher on timer
    this.ngIdle.initilizeSessionTimeout();
    this.ngIdle.userIdlenessChecker.subscribe((status: string) => {
      this.initiateFirstTimer(status);
    });
  }

  initiateFirstTimer = (status: string) => {
    switch (status) {
      case 'INITIATE_TIMER':
        break;

      case 'RESET_TIMER':
        break;

      case 'STOPPED_TIMER':
        this.sessiontimeout();

        break;

      default:
        break;
    }
  }


  sessiontimeout(): void {

    // stop all timer and end the session
    NgIdleService.runTimer = false;
    NgIdleService.runSecondTimer = false;

    this.authService.Logout().subscribe(res => {
      if (this.dataService.is_sso == true) {
        this.router.navigate(['/sso-logout']);
        // let url = this.dataService.sso_url;
        //window.location.href = url;
      }
      else {
        this.router.navigate(['/login']);
        return;
      }
      if (this.dataService.Authentication_Type == "AZURE") {
        this.msalservice.logout();
      }
    });
  }

}

export class UserInfo {
  public userName: string = "";
  public roleName: string = "";
  public userEmail: string = "";
  public groupName: string = "";
  public groupLogo: string = "";
  public lastLoginAt: string = "";
  public projectName: string = "";
  public subgroupName: string = "";
  public language: string = "EN";
  public HeaderLogo: string = "../../assets/img/Cognix_workflow_header.png";
  public currentpage: string = "";

}
